/**
 * The sort order to use when a column is first sorted.
 */
export const DEFAULT_SORT_ORDER = "descending";
